<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <transition name="fade">
          <Plan />
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Plan from "./Plan";
import Soumission from "./Soumission";

export default {
  name: "EditSoumission",
  components: {
    Plan,
    Soumission
  },
  data() {
    return {
      last_created_vertical: 10,
      categorie: "",
      categoriesList: [],
      productsList: [],
      soumission: {}
    };
  },
  methods: {
    CheckLogedin: function() {
      if (localStorage.getItem("token")) {
        return true;
      } else {
        return false;
      }
    },
    PrepareData: function() {
      // Get Data from DB

      if (localStorage.getItem("token")) {
        var dheader = {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("token")
        };
      } else {
        var dheader = { "Content-Type": "application/json" };
      }

      this.$http
        .get(this.$url_name + "/submission/" + this.$route.params.sid + "/", {
          headers: dheader
        })
        .then(response => {
          this.soumission = response.body;
        })
        .catch(err => {
          console.log(err.status);
        });
    }
  },
  mounted() {
    this.PrepareData();
  }
};
</script>

<style scoped>
.menu-product {
  list-style-type: none;
  padding-left: 0px;
}
.menu-product li {
  padding-bottom: 20px;
}
.table-produits {
  width: 100%;
}
.sub-menu-left li {
  padding-bottom: 10px;
  padding-left: 15px;
}
input {
  width: 100%;
}
.plan {
  margin-left: 40px;
}
#products-wrapper {
}

#products-wrapper #categories-products-list {
  list-style-type: none;
  padding: 0px;
}

#products-wrapper #categories-products-list li {
  float: left;
}

#products-wrapper .main-item-list {
  padding: 0;
  list-style-type: none;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditSoumission.vue